export const BASECONFIG = {
  BASE_URL:process.env.REACT_APP_API_BACKEND_URL 

};

